// imports
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"

// classes
import Experience from "./Experience"

export default class Controls
{
    constructor() 
    {
        // setup
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.debug = this.experience.debug
        this.camera = this.experience.camera
        this.animationController = this.experience.animationController

        this.setControls()
    }

    setControls()
    {
        this.instanceParameters =
        {
            controlsStatus: false,

            dampingStatus: true,
            dampingFactor: 0.05,

            zoomStatus: true,
            panStatus: true,

            maxPAngle: Math.PI / 2 - 0.05
        } 


        this.instance = new OrbitControls( this.camera.instance, this.canvas )
        this.instance.enabled = this.instanceParameters.controlsStatus

        this.instance.enableDamping = true
        this.instance.dampingFactor = this.instanceParameters.dampingFactor

        this.instance.enableZoom = this.instanceParameters.zoomStatus
        this.instance.enablePan = this.instanceParameters.panStatus

        this.instance.maxPolarAngle = this.instanceParameters.maxPAngle
    }

    update()
    {
        if( this.instanceParameters.controlsStatus )
            this.instance.update()
    }

    setDebug()
    {
        this.folder = this.debug.ui.addFolder(  
        {
            title: "Controls",
            expanded: false,

        } ).on( "change", ( _changeInfo ) => this.handleChange( _changeInfo ) )

        this.tabs = this.folder.addTab(  
        {
            pages:
            [
                { title: "Parameters" },
                // used in the CharacterController file
                { title: "Character" },
            ]
        } )

        this.parametersFolder = this.tabs.pages[0]

        // parameters
        this.parametersFolder.addBlade( 
        {
            view: "list",
            label: "controlsStatus",

            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false },
            ],

            value: this.instanceParameters.controlsStatus
        } )

        this.parametersFolder.addBlade(
        {
            view: "list",
            label: "zoomStatus",
            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false }
            ],
            value: this.instanceParameters.zoomStatus
        } )

        this.parametersFolder.addBlade(
        {
            view: "list",
            label: "panStatus",
            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false }
            ],
            value: this.instanceParameters.panStatus
        } )

        this.parametersFolder.addBlade( 
        {
            view: "list",
            label: "dampingStatus",

            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false },
            ],

            value: this.instanceParameters.dampingStatus
        } )

        this.parametersFolder.addInput( this.instanceParameters, "dampingFactor", 
        {
            min: 0.001,
            max: 2,
            step: 0.0001
        } )

        this.parametersFolder.addBlade(
        {
            view: "list",
            label: "maxPAngle",

            options:
            [
                { text: "Straight", value: 0 },
                { text: "Straight&Down", value: Math.PI / 2 - 0.05 },

            ],

            value: this.instanceParameters.maxPAngle
        } )
    }

    handleChange( _changeInfo )
    {
        const label = _changeInfo.target.controller_.view.labelElement.innerText

        this.instanceParameters.controlsStatus = label === "controlsStatus" ? _changeInfo.value : this.instanceParameters.controlsStatus

        this.instanceParameters.dampingStatus = label === "dampingStatus" ? _changeInfo.value : this.instanceParameters.dampingStatus
        this.instanceParameters.zoomStatus = label === "zoomStatus" ? _changeInfo.value : this.instanceParameters.zoomStatus
        this.instanceParameters.panStatus = label === "panStatus" ? _changeInfo.value : this.instanceParameters.panStatus

        this.instanceParameters.maxPAngle = label === "maxPAngle" ? _changeInfo.value : this.instanceParameters.maxPAngle

        this.instance.enabled = this.instanceParameters.controlsStatus
        this.instance.enableDamping = this.instanceParameters.dampingStatus
        this.instance.enableZoom = this.instanceParameters.zoomStatus
        this.instance.enablePan = this.instanceParameters.panStatus
        this.instance.maxPolarAngle = this.instanceParameters.maxPAngle
    }
}